import { useMemo, useState } from 'react'
import { USERS_TABLE } from '@/components/Settings/settingsTablePlaceholders'

export function useUsersTableModel() {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [menuUserId, setMenuUserId] = useState(null)
  const [userQuery, setUserQuery] = useState('')
  const openMenu = Boolean(menuAnchor)
  const filteredUsers = useMemo(() => {
    const q = userQuery.trim().toLowerCase()
    if (!q) return USERS_TABLE
    return USERS_TABLE.filter((row) =>
      [row.name, row.email, row.role, row.seat, row.extra, row.status.label].some((field) =>
        String(field).toLowerCase().includes(q),
      ),
    )
  }, [userQuery])
  const handleOpenMenu = (event, userId) => {
    setMenuAnchor(event.currentTarget)
    setMenuUserId(userId)
  }
  const handleCloseMenu = () => {
    setMenuAnchor(null)
    setMenuUserId(null)
  }
  return {
    userQuery,
    setUserQuery,
    filteredUsers,
    openMenu,
    menuAnchor,
    menuUserId,
    handleOpenMenu,
    handleCloseMenu,
  }
}
